import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    placeholders: Array,
  };

  static targets = ["sectionSelector"];

  connect() {
    this.defineTargets();
    this.updateContentSection();
  }

  defineTargets() {
    this.placeholdersValue.forEach((value) => {
      this[`${value}Target`] = this.element.querySelector(
        `[data-forms--content-sections-target="${value}"]`,
      );
    });
  }

  hasTarget(placeholder) {
    return !!this[`${placeholder}Target`];
  }

  updateContentSection() {
    this.hideAllSections();
    const selectedOption = this.sectionSelectorTarget.selectedOptions[0];
    const placeholders = selectedOption.dataset.sectionPlaceholders.split(" ");
    placeholders.forEach((placeholder) => {
      if (placeholder.length && this.hasTarget(placeholder)) {
        this[`${placeholder}Target`].classList.remove("d-none");
      }
    });
  }

  hideAllSections() {
    this.placeholdersValue.forEach((placeholder) => {
      if (this.hasTarget(placeholder)) {
        this[`${placeholder}Target`].classList.add("d-none");
      }
    });
  }
}
